import { isValidDateObject } from '../validator/is-valid-date-object'

/**
 * Tries to cast date value into Date, and checks if it's a valid Date object
 * It's purpose in general is to be used with numeric timestamps and string ISO representations of dates,
 * @param {string|number} date - date value to cast
 * @returns {Date|null}
 */
export const toDate = date => {
    // check against null to avoid null to 01/01/1970 conversion in new Date constructor
    const castedDate = date != null && new Date(date)
    return isValidDateObject(castedDate) ? castedDate : null
}
